import { CgUnavailable } from "react-icons/cg";
import "./ServiceUnavailble.css";

export function ServiceUnavailble(props) {

	function getError() {
		const error = props.error;

		if (typeof error === 'string') return error;

		if (error.response?.data) {
			if (typeof error.response.data === 'string' && error.response.data.startsWith('<!DOCTYPE html>')) {
				return error.response.data;
			}
			if ('message' in error.response.data) {
				return error.response.data.message;
			}
		}

		return error?.message ?? '';
	}

	return (
		<div className="service-unavailable-container">
			<CgUnavailable size={72} color='#ff6d6d' />
			<h3>Serviço indisponível</h3>
			{props.error && (
				<p dangerouslySetInnerHTML={{ __html: getError() }}></p>
			)}
		</div>
	);
}